/**
 * Lo que trae una respuesta de core por el BFF: core responde
 * `{ isSuccess, data }`, y el BFF la reenvía sin rearmarla. Sin el sobre, el
 * cuerpo tal cual.
 */
export function datosDeCore(cuerpo: unknown): unknown {
  if (cuerpo && typeof cuerpo === "object" && "isSuccess" in cuerpo) {
    return (cuerpo as { data?: unknown }).data;
  }
  return cuerpo;
}
